import { ActionContext, ActionTree } from 'vuex';
import { RootState, AuthState } from '../../types';
import { LoginData } from '@/models/login';
import authService from '@/services/auth.service';
import { AuthData } from '@/models/auth';

const actions: ActionTree<AuthState, RootState> = {
  setLoginData(
    store: ActionContext<AuthState, RootState>,
    { email, password }: LoginData
  ): void {
    store.commit('setLoginData', { email, password });
  },

  async login(
    store: ActionContext<AuthState, RootState>
  ): Promise<AuthData | string> {
    return authService.postToken(store.state.login).then(authData => {
      store.commit('authSuccess', authData);
      store.commit('setLoginData', { email: '', password: '' });
      return Promise.resolve(authData);
    });
  },

  async recoverPassword(
    store: ActionContext<AuthState, RootState>
  ): Promise<any> {
    return authService.postRecover(store.state.login.email);
  },

  async changePassword(
    store: ActionContext<AuthState, RootState>
  ): Promise<any> {
    const password = store.state.changePassword.new,
      token = store.state.data.accessToken;

    return authService.putNewPassword(password, token);
  },

  logout(store: ActionContext<AuthState, RootState>): Promise<void> {
    return new Promise(resolve => {
      store.commit('logout');
      this.commit('org/invoices/clearSearch');
      this.commit('org/products/clearSearch');
      resolve();
    });
  },
};

export default actions;
